<div class="columns small-12 medium-6" data-masonry-item="">
  <mprd-available-speed-skeleton *ngIf="isPending"></mprd-available-speed-skeleton>
  <div class="panel rs-bg-grey1" *ngIf="!isPending">
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
      {{ 'internet.availableSpeed.title' | translate }}
    </h3>
    <div class="clearfix">
      <div *ngIf="!hasError && availableSpeed">
        <div class="rs-flex-row" data-cy="countersInfo">
          <div class="rs-flex-columns small-6">
            <div>
              <div class="rs-txt-s3 rs-font-pxB">
                {{ 'internet.availableSpeed.countersInfo.counterName.download.label' | translate }}
                <i
                  class="rs-txt-purple {{
                    'internet.availableSpeed.countersInfo.counterName.download.icon' | translate
                  }}"
                  aria-hidden="true"
                ></i>
              </div>
              <p class="rs-txt-purple rs-font-pxB">
                {{ availableSpeed?.download?.value }}
                {{ getCounterUnitLabel(availableSpeed?.download) }}
              </p>
            </div>
          </div>
          <div class="rs-flex-columns small-6">
            <div class="text-right">
              <div class="rs-txt-s3 rs-font-pxB">
                {{ 'internet.availableSpeed.countersInfo.counterName.upload.label' | translate }}
                <i
                  class="rs-txt-purple {{
                    'internet.availableSpeed.countersInfo.counterName.upload.icon' | translate
                  }}"
                  aria-hidden="true"
                ></i>
              </div>
              <p class="rs-txt-purple rs-font-pxB">
                {{ availableSpeed?.upload?.value }}
                {{ getCounterUnitLabel(availableSpeed?.upload) }}
              </p>
            </div>
          </div>
        </div>
        <p *ngIf="availableSpeed?.dataBoostPresent" data-cy="dataBoostLabel">
          {{ 'internet.availableSpeed.dataBoost.label' | translate }}
        </p>
        <div class="medium-text-right" data-cy="moreInfo">
          <a
            href="{{ 'internet.availableSpeed.moreInfo.link' | translate }}"
            class="rs-btn rs-btn-third"
            data-tms-event="button-click"
            data-tms-button-zone="speed informations"
            data-tms-button-name="more info"
          >
            {{ 'internet.availableSpeed.moreInfo.label' | translate }}
            <span class="show-for-sr">{{
              'internet.availableSpeed.moreInfo.label' | translate
            }}</span>
            <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <px-alert
        *ngIf="hasError"
        [alerts]="[
          {
            type: 'error',
            description: 'internet.availableSpeed.error.message' | translate,
            isClosable: false,
            taggingErrorType: 'backend'
          }
        ]"
      ></px-alert>
    </div>
  </div>
</div>
